import badoomRoutes from './badoom/routes'

const routes = [...badoomRoutes]

export default routes
